module.exports = __webpack_public_path__ + "static/media/katusiime_ndera2.ba038dc0.jpg";